import { render } from "./pairing-batch-show.vue?vue&type=template&id=9294da84&lang=pug"
import script from "./pairing-batch-show.vue?vue&type=script&lang=js"
export * from "./pairing-batch-show.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__